import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Country } from "@shared/models/country";
import { Organization } from "@shared/models/organization";
import { RegionData } from "@shared/models/region-data";
import { Site } from "@shared/models/site";
import { User } from "@shared/models/user/user";
import { environment } from "environments/environment";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SitesAreaService {
    private baseUrl = `${environment.exploreURL}/api`;

    constructor(private http: HttpClient) { }
    private countriesSubject = new BehaviorSubject<any[]>([]);
    private regionsSubject = new BehaviorSubject<any[]>([]);
  
    countries$ = this.countriesSubject.asObservable();
    regions$ = this.regionsSubject.asObservable();
  
    setCountries(countries: any[]): void {
      this.countriesSubject.next(countries);
    }
  
    setRegions(regions: any[]): void {
      this.regionsSubject.next(regions);
    }
  
    getStoredCountries(): any[] {
      return this.countriesSubject.getValue();
    }
  
    getStoredRegions(): any[] {
      return this.regionsSubject.getValue();
    }
        getRegions(): Observable<RegionData[]> {
            return this.http.get<RegionData[]>(`${this.baseUrl}/Regions/Detailled`);
        }
        getOrganisations(): Observable<Organization[]> {
            return this.http.get<Organization[]>(`${this.baseUrl}/Organization`);
        }
        getCountries(): Observable<Country[]> {
            return this.http.get<Country[]>(`${this.baseUrl}/Countries`);
        }
        getSitesByRegionId(regionId: number): Observable<Site[]> {
            return this.http.get<Site[]>(`${this.baseUrl}/Sites/Region/${regionId}`);
        }
        createArea(region: RegionData): Observable<RegionData> {
            return this.http.post<RegionData>(`${this.baseUrl}/Regions`,region);
        }
        updateArea(region: RegionData): Observable<RegionData> {
            return this.http.put<RegionData>(`${this.baseUrl}/Regions`,region);
        }
        getSiteById(siteId: number): Observable<Site> {
            return this.http.get<Site>(`${this.baseUrl}/Sites/${siteId}`);
        }

    getUsersBySiteId(siteId: number): Observable<User[]> {
        return this.http.get<User[]>(`${this.baseUrl}/Sites/${siteId}/Users`);
    }
    createSite(site: Site): Observable<Site> {
        return this.http.post<Site>(`${this.baseUrl}/Sites`,site);
    }
    updateSite(site: Site): Observable<Site> {
        return this.http.put<Site>(`${this.baseUrl}/Sites`,site);
    }
    deleteSite(siteId: number): Observable<any> {
        return this.http.delete(`${this.baseUrl}/Sites/${siteId}`);
    }

}